export const LIST = "COMMISSION_REPORT_DEPOSIT_LIST";